<template lang='pug'>
  v-container
    v-layout( row wrap )

      v-flex( xs12 )
        v-expansion-panel
          v-expansion-panel-content
            template( slot='header' )
              h3.body-2 Fechas
            date-field.px-4( label='Desde' outline v-model='created_at_min' )
            date-field.px-4( label='Hasta' outline v-model='created_at_max' )
            .pa-4
              v-btn( block color='secondary' dark large @click='getSales()' ) Filtrar

      v-flex( xs12 )
        br

    v-flex( xs12 style='height: 400px; max-height: 400px; overflow-y: scroll;' )
      v-expansion-panel.mb-3(  )
        v-expansion-panel-content( v-for='sale in sales' )
          v-layout( slot='header' row wrap )
            v-flex.xs8 {{ sale.createdAt }}
            v-flex.xs4.text-xs-right.pr-3 {{ sale.total | mixFormatCurrency }}
            v-flex.xs8 
              span 
                b CLI: {{ sale.customer ? sale.customer.name : "-" }}
              br
              span 
                b SUC: {{ sale.customer ? sale.customer.branch_office : "-" }}
            v-flex.xs4.text-xs-right.pr-3
              span {{ sale.id ? "N°" : "" }}
              span {{ sale.folio || "NF" }}
              br
              span 
                  b SD: {{ sale.dispatchRequest ? sale.dispatchRequest.id : "" }}
          v-list
              v-list-tile( v-for='detail in sale.details' )
                  MobileCartItem(:item='formatSaleDetail(detail)') 
    h2.text-xs-center Total No Facturado: {{ notInvoiceTotal | mixFormatCurrency }}
    h2.text-xs-center Total Facturado: {{ invoiceTotal | mixFormatCurrency }}
    h2.text-xs-center Total: {{ invoiceTotal + notInvoiceTotal | mixFormatCurrency }}
</template>

<script>
import PosSale from '../../models/POS/PosSale'
import { mapGetters } from 'vuex'
import MobileCartItem from '../MobileCart/MobileCartItem'
import CurencyUtils from '@/mixins/CurrencyUtils'
import DateField from '../../components/DateField/DateField'
import PosLastSalesService from '@/services/API/POS/PosLastSales'
export default {
    components: { MobileCartItem, DateField },
    mixins: [CurencyUtils],
    data: () => ({ sales: [], created_at_min: '', created_at_max: '' }),
    computed: {
        ...mapGetters('AuthModule', {
            groundSellerId: 'groundSellerId',
        }),
        invoiceTotal() {
            return this.sales.reduce(
                (total, sale) => (total += sale.folio ? sale.total : 0),
                0
            )
        },
        notInvoiceTotal() {
            return this.sales.reduce(
                (total, sale) =>
                    (total += !sale.folio
                        ? sale.total
                        : 0),
                0
            )
        },
    },
    methods: {
        /**
         * Get all sales between the max and min dates provides
         */
        getSales() {
            let createdAtMax = this.created_at_max
            let createdAtMin = this.created_at_min
            // PosLastSalesService.getAllDefault().then((res) => {
            PosLastSalesService.getAllByDates(createdAtMax, createdAtMin).then((res) => {
                this.sales = res.data
            })
        },
        async initData() {
            let today = new Date()
            let month = today.getUTCMonth() + 1
            let year = today.getYear() + 1900
            /*let date = today.getUTCDate()*/
            this.created_at_min = `${year}-${month}-01`
            this.created_at_max = `${month === 12 ? year + 1 : year}-${
                month === 12 ? 1 : month + 1
            }-01`
            // await this.fetchSales()
            this.getSales()
        },
        async fetchSales() {
            let sales = await new PosSale()
                .where('g_seller_user_id', this.groundSellerId)
                .where('created_at_min', this.created_at_min)
                .where('created_at_max', this.created_at_max)
                .where('pos_sale_type_id', 2)
                .where('pos_origin_sale_id', 2)
                .include(
                    'pos_detail_sales',
                    'sl_customer',
                    'wh_dispatch_request.sl_sale_invoice',
                    'sl_customer_branch_offices'
                )
                .limit(-1)
                .orderBy('-created_at')
                .get()
            this.sales = sales.data
        },
        formatSaleDetail(detail) {
            return {
                name: detail.name,
                alias_name: detail.alias,
                quantity: detail.quantity,
                sale_price: detail.price,
                subtotal: detail.total,
            }
        },
    },
    async created() {
        await this.initData()
    },
}
</script>
